import { formatCurrency } from "@oefr/utils/formatter/currency"
import { useTranslations } from "next-intl"
import { AffiliateCode } from "@/constants/affiliateCode"
import { type OnboardingFormValues } from "../wizard/types/onboardingFormValues"

type UseBannerTextProps = Pick<OnboardingFormValues, "affiliateCode" | "journeyType" | "reward"> & {
    recommendedSubscribedMaxPower: number | null
}

export function useOnboardingBannerText({
    affiliateCode,
    journeyType,
    recommendedSubscribedMaxPower,
    reward,
}: UseBannerTextProps) {
    const t = useTranslations("useOnboardingBannerText")

    if (affiliateCode === AffiliateCode.RENAULT_INTELLIGENT_OCTOPUS) {
        return t("renaultIntelligentOctopusOffer")
    }

    if (affiliateCode === AffiliateCode.ACHETONS_GROUPE_NOV) {
        return t("achetonsGroupeNovOffer")
    }

    if (affiliateCode === AffiliateCode.FORD_1_YEAR) {
        return t("fordOneYearOffer")
    }

    if (affiliateCode === AffiliateCode.FORD_3_YEARS) {
        return t("fordThreeYearsOffer")
    }

    if (!reward && !recommendedSubscribedMaxPower) return null

    if (reward?.referredRewardAmount && recommendedSubscribedMaxPower) {
        return reward?.referrerGivenName && reward?.referrerRewardAmount
            ? t("referral.maxPower", {
                  recommendedSubscribedMaxPower,
                  referredRewardAmount: formatCurrency(reward.referredRewardAmount),
                  referrerGivenName: reward.referrerGivenName,
              })
            : t("promo.maxPower", {
                  referredRewardAmount: formatCurrency(reward.referredRewardAmount),
                  recommendedSubscribedMaxPower,
              })
    }

    if (reward?.referredRewardAmount) {
        return reward?.referrerGivenName && reward?.referrerRewardAmount
            ? t("referral.default", {
                  referredRewardAmount: formatCurrency(reward.referredRewardAmount),
                  referrerRewardAmount: formatCurrency(reward.referrerRewardAmount),
                  referrerGivenName: reward.referrerGivenName,
              })
            : t("promo.default", {
                  referredRewardAmount: formatCurrency(reward.referredRewardAmount),
              })
    }

    return recommendedSubscribedMaxPower && journeyType === "CHANGE_OF_SUPPLIER"
        ? t("maxPower", { recommendedSubscribedMaxPower })
        : null
}

useOnboardingBannerText.messages = ["useOnboardingBannerText"] as const
